/* Find My Match — self-contained PDP product-recommendation quiz.
 * Frontend only. Config baked in. NEVER calls /cart/add.js — result CTA is a Learn More link.
 * Fetches product title/price/image LIVE from /products/<handle>.js so nothing goes stale.
 */
(function () {
  'use strict';

  var FMM_CONFIG = {
    start: 'q_goal',
    questions: {
      q_goal: {
        title: 'What would you most love to improve?',
        options: [
          { label: '🪞 Fine lines & wrinkles',     goal: 'smoothing fine lines & wrinkles', next: 'q_lines' },
          { label: '💪 Firmness & lift',            goal: 'firmness & lift',                 next: 'q_firm' },
          { label: '👁️ Tired-looking eyes',         goal: 'brightening tired-looking eyes',  next: 'q_eyes' },
          { label: '💧 Dryness & dullness',         goal: 'deep hydration & glow',           next: 'q_dry' },
          { label: '🌙 Overnight repair & renewal', goal: 'overnight repair & renewal',      next: 'q_pm' },
          { label: '🧼 A gentle everyday cleanse',  goal: 'a gentle everyday cleanse',       next: 'q_cleanse' }
        ]
      },
      q_lines: {
        title: 'Where do they bother you most?',
        options: [
          { label: 'On my face',                    match: 'repair-and-release-cream' },
          { label: 'Around the mouth / deep folds', match: 'collagen-filler-serum' },
          { label: 'My neck',                       match: 'neck-lift-cream' }
        ]
      },
      q_firm: {
        title: 'Which area would you most like to lift?',
        options: [
          { label: 'Face / cheeks',  match: 'repair-and-release-cream' },
          { label: 'Neck / jawline', match: 'neck-lift-cream' },
          { label: 'Eyes',           match: 'south-beach-eye-serum' }
        ]
      },
      q_eyes: {
        title: 'What bothers you most around your eyes?',
        options: [
          { label: 'Dark circles', match: 'south-beach-eye-serum', echo: 'dark circles' },
          { label: 'Puffiness',    match: 'south-beach-eye-serum', echo: 'puffiness' },
          { label: "Crow's feet",  match: 'south-beach-eye-serum', echo: "crow's feet" }
        ]
      },
      q_dry: {
        title: 'How does your skin usually feel?',
        options: [
          { label: 'Dull',        match: 'collagen-filler-serum' },
          { label: 'Dry / tight', match: 'repair-and-release-cream' }
        ]
      },
      q_pm: {
        title: 'What would you love to wake up to?',
        options: [
          { label: 'Smoother, firmer skin', match: 'peptide-pm-shield' },
          { label: 'Brighter eyes',         match: 'south-beach-eye-serum' }
        ]
      },
      q_cleanse: {
        title: 'How would you describe your skin?',
        options: [
          { label: 'Dry / sensitive', match: 'lavender-oil-cleanser' },
          { label: 'Normal / combo',  match: 'lavender-oil-cleanser' }
        ]
      }
    },
    matches: {
      'repair-and-release-cream': { reason: 'our all-in-one anti-aging hero for face and neck',
        bullets: ['Targets lines, firmness, and hydration in one step', 'Works across the face and neck where aging shows first'] },
      'collagen-filler-serum': { reason: 'our collagen-boosting serum for deeper lines and folds',
        bullets: ['Helps plump and soften deep lines and folds', 'Boosts collagen for firmer, more radiant skin'] },
      'south-beach-eye-serum': { reason: 'our targeted treatment for the delicate eye area',
        bullets: ['Helps brighten dark circles and de-puff tired eyes', 'Smooths the look of crow’s feet around the eyes'] },
      'neck-lift-cream': { reason: 'our firming cream for the neck, jawline and décolleté',
        bullets: ['Firms and tightens crepey skin on the neck and jawline', 'Targets the décolleté, an area most creams skip'] },
      'lavender-oil-cleanser': { reason: "our gentle cleanser that won't dry you out",
        bullets: ['Melts away makeup and impurities without stripping', 'Gentle enough for dry and sensitive skin'] },
      'peptide-pm-shield': { reason: 'our overnight peptide treatment for repair and renewal',
        bullets: ['Works overnight to repair and renew while you sleep', 'Peptides support a stronger moisture barrier'] }
    }
  };

  var FOCUSABLE = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';
  var productCache = {};

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatPrice(cents) {
    // price from /products/<handle>.js is an INTEGER in cents.
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function imageUrl(product) {
    var src = product.featured_image || (product.images && product.images[0]) || '';
    if (!src) return '';
    // featured_image is protocol-relative ("//cdn…") — make it absolute.
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) { productCache[handle] = data; return data; });
  }

  function FMM(root) {
    if (root.__fmmInit) return; // guard against double-init
    root.__fmmInit = true;

    var trigger = root.querySelector('[data-fmm-open]');
    var modal = root.querySelector('[data-fmm-modal]');
    var questionMount = root.querySelector('[data-fmm-question]');
    var resultMount = root.querySelector('[data-fmm-result]');
    var closeEls = root.querySelectorAll('[data-fmm-close]');
    if (!trigger || !modal || !questionMount || !resultMount) return;

    var state = { stepId: FMM_CONFIG.start, history: [], goal: '' };
    var lastFocused = null;

    function renderQuestion(stepId) {
      var q = FMM_CONFIG.questions[stepId];
      if (!q) return;
      state.stepId = stepId;
      resultMount.hidden = true;
      resultMount.innerHTML = '';
      questionMount.hidden = false;

      var html = '<h2 class="find-my-match__title" id="fmm-title">' + esc(q.title) + '</h2>';
      html += '<ul class="find-my-match__options" data-fmm-options>';
      q.options.forEach(function (opt, i) {
        html += '<li><button type="button" class="find-my-match__option" data-fmm-index="' + i + '">' +
          '<span class="find-my-match__option-label">' + esc(opt.label) + '</span>' +
          '</button></li>';
      });
      html += '</ul>';
      questionMount.innerHTML = html;

      questionMount.querySelectorAll('.find-my-match__option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var opt = q.options[parseInt(btn.getAttribute('data-fmm-index'), 10)];
          if (opt.goal) state.goal = opt.goal;
          if (opt.next) {
            state.history.push(stepId);
            renderQuestion(opt.next);
          } else if (opt.match) {
            renderResult(opt.match);
          }
        });
      });

      var first = questionMount.querySelector('.find-my-match__option');
      if (first && modalOpen) first.focus();
    }

    function renderResult(handle) {
      var meta = FMM_CONFIG.matches[handle] || { reason: '', bullets: [] };
      questionMount.hidden = true;
      questionMount.innerHTML = '';
      resultMount.hidden = false;
      resultMount.innerHTML = '<p class="find-my-match__loading">Finding your match…</p>';

      fetchProduct(handle).then(function (product) {
        var img = imageUrl(product);
        var price = formatPrice(product.price);
        var bullets = (meta.bullets || []).map(function (b) {
          return '<li class="find-my-match__bullet">' +
            '<span class="find-my-match__bullet-check" aria-hidden="true">✓</span>' +
            '<span class="find-my-match__bullet-text">' + esc(b) + '</span></li>';
        }).join('');

        var html = '<h2 class="find-my-match__title find-my-match__title--center" id="fmm-title">Your Perfect Match</h2>';
        html += '<p class="find-my-match__result-line">Since you’re focused on ' +
          esc(state.goal) + ', we’d pair you with the ' + esc(product.title) + ' — ' +
          esc(meta.reason) + '.</p>';
        html += '<div class="find-my-match__card">';
        if (img) {
          html += '<div class="find-my-match__card-media"><img src="' + esc(img) +
            '" alt="' + esc(product.title) + '" loading="lazy" /></div>';
        }
        html += '<div class="find-my-match__card-body">';
        html += '<p class="find-my-match__card-title">' + esc(product.title) + '</p>';
        if (price) html += '<p class="find-my-match__card-price">' + esc(price) + '</p>';
        if (bullets) html += '<ul class="find-my-match__bullets">' + bullets + '</ul>';
        html += '</div></div>';
        html += '<a class="find-my-match__cta" href="/products/' + esc(handle) + '">Learn More</a>';
        html += '<button type="button" class="find-my-match__restart" data-fmm-restart>Take Quiz Again</button>';
        resultMount.innerHTML = html;
        bindResult();
        var cta = resultMount.querySelector('.find-my-match__cta');
        if (cta && modalOpen) cta.focus();
      }).catch(function () {
        // Graceful fallback — never a blank card; still offer the PDP link + retry.
        var html = '<h2 class="find-my-match__title find-my-match__title--center" id="fmm-title">Your Perfect Match</h2>';
        html += '<p class="find-my-match__result-line">Since you’re focused on ' +
          esc(state.goal) + ', we’d pair you with ' + esc(meta.reason) + '.</p>';
        html += '<a class="find-my-match__cta" href="/products/' + esc(handle) + '">Learn More</a>';
        html += '<button type="button" class="find-my-match__restart" data-fmm-restart>Take Quiz Again</button>';
        resultMount.innerHTML = html;
        bindResult();
        var cta = resultMount.querySelector('.find-my-match__cta');
        if (cta && modalOpen) cta.focus();
      });
    }

    function bindResult() {
      var restart = resultMount.querySelector('[data-fmm-restart]');
      if (restart) {
        restart.addEventListener('click', function () {
          state = { stepId: FMM_CONFIG.start, history: [], goal: '' };
          renderQuestion(FMM_CONFIG.start);
        });
      }
    }

    /* ---- Accessibility: open/close, focus trap, ESC, backdrop ---- */
    var modalOpen = false;

    function open() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      modalOpen = true;
      document.addEventListener('keydown', onKeydown, true);
      // Reset to Q1 each open for a clean start.
      state = { stepId: FMM_CONFIG.start, history: [], goal: '' };
      renderQuestion(FMM_CONFIG.start);
      // Move focus into the dialog.
      var first = modal.querySelector(FOCUSABLE) || modal;
      first.focus();
    }

    function close() {
      modal.hidden = true;
      modalOpen = false;
      document.removeEventListener('keydown', onKeydown, true);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      } else {
        trigger.focus();
      }
    }

    function focusables() {
      return Array.prototype.filter.call(
        modal.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
    }

    function onKeydown(e) {
      if (!modalOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key === 'Tab') {
        var items = focusables();
        if (!items.length) { e.preventDefault(); modal.focus(); return; }
        var firstEl = items[0];
        var lastEl = items[items.length - 1];
        var active = document.activeElement;
        if (e.shiftKey) {
          if (active === firstEl || !modal.contains(active)) {
            e.preventDefault();
            lastEl.focus();
          }
        } else {
          if (active === lastEl || !modal.contains(active)) {
            e.preventDefault();
            firstEl.focus();
          }
        }
      }
    }

    trigger.addEventListener('click', open);
    Array.prototype.forEach.call(closeEls, function (el) {
      el.addEventListener('click', close);
    });
  }

  function init() {
    document.querySelectorAll('[data-find-my-match]').forEach(function (root) {
      FMM(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
